import i18n from '../../i18n'
import requiredRules from './requiredRules'

const alphaNumericRules = (v) => [
  ...requiredRules(v),
  !/[^\w-.]/.test(v) || i18n.t('warnings.validation.alpha_numeric')
]

export default alphaNumericRules
